module.exports = __webpack_public_path__ + "media/images/icon-call-52cba0b1dc8e58f9b4fa95c777df61da.svg";